import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { ArrowRight } from "lucide-react";
import heroImage from "@/assets/peter-dingle-hero.jpg";
import { useLanguage } from "@/i18n/LanguageContext";

const HeroSection = () => {
  const { t } = useLanguage();

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center pt-32 pb-24 bg-gradient-to-br from-primary via-foreground/95 to-foreground/90"
    >
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW9wYWNpdHk9Ii4wMiIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9nPjwvc3ZnPg==')] opacity-30" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
          <div className="text-white space-y-8 animate-fade-in-up">
            <div className="space-y-6">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold leading-[1.1] tracking-tighter">
                {t("hero.title")}
              </h1>
              <p className="text-lg sm:text-xl text-white/80 leading-relaxed max-w-xl font-serif">
                {t("hero.p1")}
              </p>
              <p className="text-base text-white/70 leading-relaxed max-w-xl font-serif">
                {t("hero.p2")}
              </p>
              <p className="text-sm font-medium text-accent-mint uppercase tracking-widest">
                {t("hero.tagline")}
              </p>
            </div>
            <Button
              variant="hero"
              size="xl"
              onClick={() => window.open("https://calendar.app.google/smFTnDe7izrtAPVg6", "_blank")}
              className="group mt-8 font-sans"
            >
              {t("hero.cta")}
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <p className="text-sm text-white/80 mt-4">
              {t("hero.note")}
            </p>
          </div>

          <div className="flex items-center justify-center lg:justify-end">
            <div className="relative w-full max-w-md animate-fade-in">
              <div className="absolute inset-0 bg-accent/20 blur-3xl rounded-full" />
              <AspectRatio ratio={9 / 16}>
                <img
                  src={heroImage}
                  alt={t("hero.imageAlt")}
                  width={720}
                  height={1280}
                  fetchPriority="high"
                  decoding="async"
                  className="relative w-full h-full object-cover rounded-sm shadow-2xl"
                />
              </AspectRatio>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
